import React, { useEffect, useState } from 'react';
import getStats from '../../api/Admin/getStats';
import styles from './AdminPanel.module.css';

const AdminStats = () => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            const res = await getStats();
            if (res.ok) {
                setStats(res.data);
            } else {
                setError('Impossible de charger les statistiques');
            }
            setLoading(false);
        };
        fetchStats();
    }, []);

    if (loading) return <div>Chargement...</div>;
    if (error) return <div className={styles.error}>{error}</div>;

    return (
        <div className={styles.stats}>
            {stats.map((stat, index) => (
                <div key={index} className={styles.stat}>
                <div className={styles.value}>{stat.value}</div>
                <div className={styles.label}>{stat.label}</div>
                </div>
            ))}
        </div>
    );
};

export default AdminStats;
